// Payload passed alongside BOOKING_SUCCESS so the native host can record
// analytics for the new (and previous, if rescheduling) session without
// needing an extra round trip. All fields are optional because we deliver
// best-effort data: sessionStartTime is always known client-side, but
// sessionId depends on the backend response shape (see
// extractSessionId).
type BookingSuccessPayload = {
  sessionId?: number;
  sessionStartTime?: string;
  previousSessionId?: number;
};

export type NativeMessageEvent =
  | ({ eventName: "BOOKING_SUCCESS" } & BookingSuccessPayload)
  | { eventName: "BOOKING_ERROR"; previousSessionId?: number }
  | { eventName: "GOOGLE_MEET_REDIRECT" }
  | { eventName: "BOOKING_REDIRECT" }
  | { eventName: "BOOK_MORE_SESSIONS"; sessionStartTime?: string };

export const sendNativeMessage = (message: NativeMessageEvent): void => {
  try {
    window.ReactNativeWebView?.postMessage(JSON.stringify(message));
  } catch {
    // Guard against postMessage throwing in unexpected WebView states
  }
};
